module.exports = __webpack_public_path__ + "img/pet_daschund.2f227bef.svg";